import { render, staticRenderFns } from "./AgendaIconDropdown.vue?vue&type=template&id=b4190124&scoped=true&"
import script from "./AgendaIconDropdown.vue?vue&type=script&lang=js&"
export * from "./AgendaIconDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AgendaIconDropdown.vue?vue&type=style&index=0&id=b4190124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4190124",
  null
  
)

export default component.exports